export default __webpack_public_path__ + "static/media/Icon feather-search.a0b0d67c.svg";